import api from '@/helpers/api'

const API_READ=`/api/member/pending-members`
const API_UPDATE=`/api/member/pending-members/`
const API_ALL_IDS=`/api/member/pending-members/all-ids`
const API_BULK_APPROVE=`/api/member/pending-members/bulk-approve`
const API_BULK_DELETE=`/api/member/pending-members/bulk-delete`

export default {
  namespaced:true,
  state: {
    status: '',
    PendingMembers:[],
    currUser: {},
    errMessage: '',
    meta:{
        limit:10,
        page:1,
        total:1
    },
    filter: {},
    search:{

    }
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state, {message}){
        state.status = 'error'
        state.errMessage = message
    },
    read(state, {PendingMembers}){
        state.PendingMembers = [...PendingMembers]
    },
    switch_page(state, {meta}){
        state.meta = {...meta}
    },
    add_filter(state, {filter}) {
        state.filter = {...filter};
    },
    set_search(state, {search}){
        state.search = {...search};
    },
    clear_search(state){
        state.search = {};
    },
    reset_meta(state) {
        state.meta = {
            limit: 10,
            page: 1,
            total: 1,
        }
    }
  },
  actions: {
    readPendingMembers({commit, state}){

        commit('request')

        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
            api.request('get', API_READ, {meta, filter, search})
            .then((result) => {
                commit('read', {PendingMembers:result.data.data})
                commit('switch_page', {meta: {...result.data.meta}})
                commit('success')
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    fetchAllPendingIds({state}){
        const {filter} = state
        const {search} = state
        const meta = { limit: 10, page: 1 }

        return new Promise((resolve, reject) => {
            api.request('get', API_ALL_IDS, {meta, filter, search})
            .then((result) => {
                return resolve(result.data.data)
            }).catch((err) => {
                return reject(err)
            });
        });
    },
    bulkApprove({commit}, ids){
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post', API_BULK_APPROVE, {}, { ids })
            .then(($request) => {
                commit('success');
                return resolve($request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    bulkDelete({commit}, ids){
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post', API_BULK_DELETE, {}, { ids })
            .then(($request) => {
                commit('success');
                return resolve($request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    update({commit},{data}){

        commit('request');
        
        return new Promise((resolve, reject) => {
            api.request('put', `${API_UPDATE}${data.id}`)
            .then(($request) => {
                commit('success');
                return resolve($request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    delete({commit},{data}){

        commit('request');
        
        return new Promise((resolve, reject) => {
            api.request('delete', `${API_UPDATE}${data.id}`)
            .then(($request) => {
                commit('success');
                return resolve($request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
  },
  getters : {
    PendingMembers: (state) => state.PendingMembers,
  }
}
